module.exports = __webpack_public_path__ + "static/media/Sensor-Monitor-white-web.f53000cc.png";